import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, ReactNode } from 'react';

import { HeaderCell } from '../../HeaderCell';

export interface HeaderProps {
  children?: ReactNode;
  enableResponsive?: boolean;
}

export const Header: FC<HeaderProps> = ({ children, enableResponsive }) => (
  <HeaderCell data-column="name" className={classNames({ 'd-none d-xxxl-table-cell': enableResponsive })}>
    <FormattedMessage id="name" />
    {children}
  </HeaderCell>
);
